import Model, { attr } from '@ember-data/model';
import {
  type ContactCustomPropertyInfo,
  type ContactCustomPropertyInfoSettings,
  type ContactCustomPropertyType,
} from 'donor-elf-web/services/contacts-cache';

export default class CustomPropertyModel extends Model {
  @attr('string') contactId!: string;
  @attr('string') l!: string;
  @attr() v!: any;
  @attr('string') t?: ContactCustomPropertyType;
  @attr('number') index?: number; // I think this can be deleted
  @attr('boolean') shouldDestroy?: boolean;
  @attr() o?: string[];
  @attr() s?: ContactCustomPropertyInfoSettings;
  @attr() customPropertyInfo?: ContactCustomPropertyInfo;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'custom-property': CustomPropertyModel;
  }
}
